const PATHS = {
	all: "*",
	root: "/",
	login: "/login",
	logout: "/logout",
	profile: "/profile",
	backend: "/backend",
	gmapst: "/map",
	privacyPolicy: "/privacyPolicy",
	mymedia: "/mymedia",
	favorites: "/favorites",
	reports: "/reports",
	manualWithdrawals: "/admin/withdrawals",
	accountDelete: "/account/delete",

	defaultAfterLogin: "/",
	defaultAfterLogout: "/"
};

export {PATHS};
